import { DateTime } from "luxon";

const DATA_PREFIX = "WIDGET_TASK_SINGLE_ADD:";

function occasion(
  day: number,
  good: boolean
): {
  readonly node: {
    readonly id: string;
    readonly occasion: {
      readonly endAt: string;
      readonly id: string;
      readonly sequenceNumber: number;
      readonly startAt: string;
    };
    readonly taskExecutions: readonly {
      readonly checkValue: "NEGATIVE" | "POSITIVE" | null;
      readonly id: string;
      readonly sectionId: string;
      readonly updatedAt: string | null;
    }[];
  };
} {
  const startDate = DateTime.local()
    .minus({ second: 1 })
    .minus({ day: day + 1 });
  const endDate = startDate.plus({ day: 1 });

  return {
    node: {
      id: DATA_PREFIX + "node" + day,
      occasion: {
        sequenceNumber: day,
        id: DATA_PREFIX + "occ" + day,
        endAt: endDate.toISO(),
        startAt: startDate.toISO(),
      },
      taskExecutions: [
        {
          id: DATA_PREFIX + "s1" + day,
          checkValue: good ? "NEGATIVE" : "POSITIVE",
          sectionId: DATA_PREFIX + "1",
          updatedAt: startDate.toISO(),
        },
      ],
    },
  };
}

export const previewWidgetTaskSingleMock = {
  id: "task",
  grouping: "SECTION",
  title: "Kontrollpunkter",
  taskSingleSize: "TWO_X_ONE",
  activeSectionVersions: [
    {
      ordinal: 0,
      section: {
        assignedTeam: {
          color: "#2D8DFF",
          id: DATA_PREFIX + "team" + "1",
          name: "Frukt",
          icon: null,
        },
        id: DATA_PREFIX + "1",
      },
      id: "",
      title: null,
    },
  ],
  task: {
    __typename: "TaskCheck",
    id: DATA_PREFIX + "tn",
    title: "Pantrummet",
    routine: {
      id: DATA_PREFIX + "routineid",
      title: "Checklista Butik",
      type: "DEFAULT",
    },
    occasions: {
      edges: [
        occasion(0, false),
        occasion(1, true),
        occasion(2, false),
        occasion(3, true),
        occasion(4, true),
      ],
    },
  },
};
